import HttpClientProtected from './http-client-protected';

export default class MainProtectedFormData extends HttpClientProtected {
  private static instanceCached: MainProtectedFormData;

  private constructor() {
    super(process.env.BASE_URL, 'multipart/form-data');
  }

  static getInstance = () => {
    if (!MainProtectedFormData.instanceCached) {
      MainProtectedFormData.instanceCached = new MainProtectedFormData();
    }

    return MainProtectedFormData.instanceCached;
  };

  public createPost(formData: FormData) {
    return this.instance.post('/posts', formData);
  }

  public editPost(id: number, formData: FormData) {
    return this.instance.patch(`/posts/${id}`, formData);
  }

  public attachToExpense(expenseId: number, formData: FormData) {
    return this.instance.post(`/expense/${expenseId}/attachments`, formData);
  }

  // A recurring line with no row of its own gets one for `period` first.
  public attachToRecurring(recurringId: number, period: string, formData: FormData) {
    return this.instance.post(`/expense/recurring/${recurringId}/attachments`, formData, {
      params: { period },
    });
  }
}
